(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lunea-cart"]) return;
  try {
    
  /* Корзина без перезагрузки: − / + и ввод количества, Remove, видео сборки (снипет
     lunea-video-addon). Количества копятся 350 мс и уходят одним /cart/update.js; секция
     приходит готовой (Section Rendering API) и подменяется на месте, счётчик в шапке —
     из data-count, фокус остаётся на той же кнопке. Запросы идут по очереди. Не вышло —
     перезагрузка страницы. Без JS работает форма и кнопка «Update quantities».
     Мелочи к заказу (lunea-upsell) и полоса доставки (lunea-ship-progress) обновляются
     той же подменой секции, отдельных запросов у них нет (25.10.2026). */
  (function () {
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var busy = false;
    var queue = [];
    var pending = {};
    var timer = null;

    function cartEl() { return document.querySelector('[data-cart]'); }
    function sectionOf() {
      var c = cartEl();
      var s = c && c.closest('.shopify-section');
      return s ? s.id.replace(/^shopify-section-/, '') : '';
    }
    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    }

    function swap(id, html) {
      var box = document.getElementById('shopify-section-' + id);
      if (!html || !box) throw new Error('no section');
      var active = document.activeElement;
      var focus = active && active.getAttribute && active.getAttribute('data-focus');
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-' + id);
      box.innerHTML = fresh ? fresh.innerHTML : html;
      var c = cartEl();
      setCount(c ? Number(c.getAttribute('data-count')) || 0 : 0);
      // то, что покупатель успел нажать, пока шёл запрос, — снова в полях
      Object.keys(pending).forEach(function (k) {
        var i = box.querySelector('input[data-line-key="' + k + '"]');
        if (i) i.value = pending[k];
      });
      if (focus) {
        var f = box.querySelector('[data-focus="' + focus + '"]');
        if (f) f.focus({ preventScroll: true });
      }
      continueLink();
      document.dispatchEvent(new CustomEvent('lunea:cart-rendered'));
    }

    // «Continue shopping» — в ту коллекцию хаба, откуда покупатель последний раз ушёл
    // на товар (её запоминает lunea-collection.liquid). Не знаем — общий каталог.
    function continueLink() {
      var a = document.querySelector('[data-cart] [data-continue]');
      if (!a) return;
      try {
        var hub = JSON.parse(sessionStorage.getItem('lunea:hub') || 'null');
        if (hub && hub.url && hub.url.indexOf('/collections') === 0) a.href = hub.url;
      } catch (err) {}
    }

    // Перезагрузка как запасной путь — не чаще раза в 10 секунд. Иначе стойкая ошибка
    // автоматического запроса при загрузке (синхронизация видео сборки) уводила корзину
    // в бесконечный круг «ошибка → перезагрузка → тот же запрос» (баг-хантинг 05.10.2026).
    function reloadOnce() {
      try {
        var t = Number(sessionStorage.getItem('lunea:cart-reload') || 0);
        if (Date.now() - t < 10000) {
          busy = false;
          var c = cartEl();
          if (c) c.removeAttribute('aria-busy');
          return;
        }
        sessionStorage.setItem('lunea:cart-reload', String(Date.now()));
      } catch (err) {}
      location.reload();
    }

    function run(url, body) {
      if (busy) { queue.push([url, body]); return; }
      var id = sectionOf();
      if (!id) { reloadOnce(); return; }
      busy = true;
      body.sections = [id];
      var c = cartEl();
      if (c) c.setAttribute('aria-busy', 'true');
      fetch(ROOT + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (json) {
          swap(id, json.sections && json.sections[id]);
          busy = false;
          if (queue.length) { var next = queue.shift(); run(next[0], next[1]); } else flush();
        })
        .catch(reloadOnce);
    }

    function flush() {
      clearTimeout(timer);
      if (busy || !Object.keys(pending).length) return;
      var updates = pending;
      pending = {};
      run('cart/update.js', { updates: updates });
    }
    function later() { clearTimeout(timer); timer = setTimeout(flush, 350); }

    function setQty(input, n) {
      n = Math.max(0, n);
      input.value = n;
      pending[input.getAttribute('data-line-key')] = n;
      // видео сборки следит за количеством боксов (lunea-video-addon)
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !cartEl()) return;
      var step = e.target.closest('[data-cart] [data-qty-step]');
      if (step) {
        var input = step.parentNode.querySelector('input[data-line-key]');
        if (!input) return;
        setQty(input, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-qty-step')));
        later();
        return;
      }
      var rm = e.target.closest('[data-cart] a[href*="/cart/change"]');
      if (rm && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
        var u = new URL(rm.href, location.href);
        var body = { quantity: 0 };
        if (u.searchParams.get('id')) { body.id = u.searchParams.get('id'); delete pending[body.id]; }
        else if (u.searchParams.get('line')) body.line = Number(u.searchParams.get('line'));
        else return;
        e.preventDefault();
        var line = rm.closest('.cart__line');
        if (line) line.style.opacity = '0.4';
        run('cart/change.js', body);
      }
    });

    // Ввод числа: по change (Enter, уход из поля).
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-cart] input[data-line-key]')) return;
      setQty(t, parseInt(t.value, 10) || 0);
      later();
    });

    // Enter в поле и «Update quantities» — сразу, без перезагрузки. «Check out» уходит
    // формой: в ней уже стоят нужные количества, Shopify применит их перед оформлением.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-cart] #cart-form')) return;
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      form.querySelectorAll('input[data-line-key]').forEach(function (i) {
        var n = Math.max(0, parseInt(i.value, 10) || 0);
        if (String(n) !== i.getAttribute('data-qty')) pending[i.getAttribute('data-line-key')] = n;
      });
      flush();
    });

    // Страница вернулась из кэша «назад» — корзина могла измениться на другой странице.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var id = sectionOf();
      if (id) {
        fetch(ROOT + 'cart?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) { swap(id, html); })
          .catch(reloadOnce);
      } else {
        fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count); })
          .catch(function () {});
      }
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', continueLink);
    else continueLink();

    window.luneaCart = { run: run };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunea-collection"]) return;
  try {
    
  /* Хаб: вкладки, выпадашка, чипсы и «Only …» переключают коллекцию без перезагрузки —
     секция приходит через Section Rendering API (?section_id=…), подменяется на месте,
     плитки переезжают (View Transitions), адрес меняется (pushState, «назад» работает).
     Соседние коллекции подгружаются заранее — в простое после загрузки и при
     наведении/касании, поэтому переключение мгновенное. Не вышло — обычный переход.
     Уходя на товар, запоминаем состояние для «← Back to …». Спека §4, §7. */
  (function () {
    var hub = document.querySelector('[data-hub]');
    if (!hub) return;
    var section = hub.closest('.shopify-section');
    var sectionId = section ? section.id.replace(/^shopify-section-/, '') : '';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 700); };
    var cache = {};
    var token = 0;
    var shown = pathOf(window.location.href); // какую коллекцию хаб показывает сейчас

    function pathOf(url) { return new URL(url, window.location.href).pathname.replace(/\/$/, ''); }
    function isHubLink(a) {
      if (!a || !a.href || a.target || a.hasAttribute('download')) return false;
      var u = new URL(a.href, window.location.href);
      return u.origin === window.location.origin && /^\/collections\/[^/]+\/?$/.test(u.pathname);
    }
    function fetchHtml(url) {
      var key = pathOf(url);
      if (!cache[key]) {
        var u = new URL(url, window.location.href);
        u.search = '';
        u.searchParams.set('section_id', sectionId);
        cache[key] = fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        });
        cache[key].catch(function () { delete cache[key]; });
      }
      return cache[key];
    }
    function prefetch(a) { if (sectionId && isHubLink(a)) fetchHtml(a.href).catch(function () {}); }

    // Где панель вкладок прилипает: низ шапки хаба минус отступ липкой панели.
    function stickY() {
      var head = hub.querySelector('.hub__head');
      var filters = hub.querySelector('.hub__filters');
      if (!head || !filters) return 0;
      return head.getBoundingClientRect().bottom + window.scrollY - parseFloat(getComputedStyle(filters).top || 0);
    }

    // Мгновенный отклик: капсула и чипс переезжают по касанию, тело приглушается до ответа.
    function feedback(a) {
      var wrap = a.closest('.hub__tabwrap');
      if (wrap) {
        var tab = wrap.querySelector('.hub__tab');
        hub.querySelectorAll('.hub__tab').forEach(function (t) { t.classList.toggle('is-on', t === tab); });
        if (wrap.classList.contains('hub__tabwrap--dd') && a.classList.contains('hub__dd-item')) wrap.classList.add('is-closed');
      }
      if (a.classList.contains('hub__chip')) {
        hub.querySelectorAll('.hub__chip').forEach(function (c) { c.classList.toggle('is-on', c === a); });
      }
      hub.classList.add('is-loading');
    }

    // Имена переходов: одинаковые товары и главы до и после — одно имя, переезжают.
    // Только на время перехода: с двумя одинаковыми именами браузер переход отменяет.
    function names(on) {
      // панель вкладок — своим слоем: если сдвинется (появились чипсы), проедет, а не задвоится
      var bar = hub.querySelector('.hub__filters');
      if (bar) bar.style.viewTransitionName = on ? 'lunea-hub-filters' : '';
      var used = {};
      hub.querySelectorAll('[data-hub-item], [data-ch]').forEach(function (el) {
        var n = el.hasAttribute('data-ch') ? 'lunea-ch-' + el.getAttribute('data-ch') : 'lunea-i-' + el.getAttribute('data-product');
        if (on && !used[n]) { used[n] = true; el.style.viewTransitionName = n; }
        else el.style.viewTransitionName = '';
      });
    }

    function swap(html, url, push) {
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hub]');
      if (!next) { window.location.href = url; return; }
      // плитки вставляются уже проявленными: появление .reveal поверх перехода — лишнее движение
      next.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      var wasStuck = window.scrollY > stickY() - 1;

      function update() {
        ['.hub__head', '.hub__body'].forEach(function (sel) {
          var a = hub.querySelector(sel);
          var b = next.querySelector(sel);
          if (a && b) a.replaceWith(b);
        });
        var chips = hub.querySelector('.hub__chips');
        var newChips = next.querySelector('.hub__chips');
        if (chips && newChips) chips.replaceWith(newChips);
        else if (chips) chips.remove();
        else if (newChips) hub.querySelector('.hub__filters').appendChild(newChips);
        // вкладки те же — переносим только состояние (капсула, aria-current, пункт выпадашки)
        var tabs = next.querySelectorAll('.hub__tab');
        hub.querySelectorAll('.hub__tab').forEach(function (t, i) {
          if (!tabs[i]) return;
          t.classList.toggle('is-on', tabs[i].classList.contains('is-on'));
          if (tabs[i].hasAttribute('aria-current')) t.setAttribute('aria-current', 'page');
          else t.removeAttribute('aria-current');
        });
        var items = next.querySelectorAll('.hub__dd-item');
        hub.querySelectorAll('.hub__dd-item').forEach(function (d, i) {
          if (items[i]) d.classList.toggle('is-on', items[i].classList.contains('is-on'));
        });
        hub.setAttribute('data-label', next.getAttribute('data-label'));
        hub.setAttribute('data-mode', next.getAttribute('data-mode'));
        if (push) history.pushState({ luneaHub: true }, '', url);
        shown = pathOf(url);
        var h1 = hub.querySelector('.hub__title');
        if (h1) document.title = document.title.replace(/^[^–|]*/, h1.textContent.trim() + ' ');
        hub.classList.remove('is-loading');
        if (wasStuck) window.scrollTo({ top: stickY(), behavior: 'instant' });
      }

      if (!document.startViewTransition || reduce.matches) { update(); return; }
      names(true);
      var t = document.startViewTransition(function () { update(); names(true); });
      t.finished.finally(function () { names(false); });
    }

    function go(url, push, a) {
      var my = ++token;
      if (a) feedback(a); else hub.classList.add('is-loading');
      fetchHtml(url).then(function (html) {
        if (my === token) swap(html, url, push);
      }).catch(function () { window.location.href = url; });
    }

    // Уходим на товар — запоминаем, откуда: адрес, прокрутку, подпись для «← Back to …».
    function remember(a) {
      var m = a.pathname.match(/^\/collections\/([^/]+)\/products\//);
      try {
        sessionStorage.setItem('lunea:hub', JSON.stringify({
          url: window.location.pathname + window.location.search,
          y: Math.round(window.scrollY),
          label: hub.getAttribute('data-label'),
          ctx: m ? m[1] : ''
        }));
      } catch (err) {}
    }

    hub.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.classList.contains('tile')) { remember(a); return; }
      if (!sectionId || !isHubLink(a)) return;
      e.preventDefault();
      if (pathOf(a.href) === pathOf(window.location.href)) {
        var w = a.closest('.hub__tabwrap--dd');
        if (w) w.classList.add('is-closed');
        return;
      }
      go(a.href, true, a);
    });
    hub.addEventListener('pointerover', function (e) { prefetch(e.target.closest && e.target.closest('a')); });
    hub.addEventListener('touchstart', function (e) { prefetch(e.target.closest && e.target.closest('a')); }, { passive: true });
    hub.querySelectorAll('.hub__tabwrap--dd').forEach(function (w) {
      w.addEventListener('mouseleave', function () { w.classList.remove('is-closed'); });
    });
    // «Назад»/«вперёд» между коллекциями. Когда браузер достаёт хаб из кэша (возврат со
    // страницы товара), popstate тоже приходит — но хаб уже показывает нужное, ничего не трогаем.
    // /collections тоже хаб (list-collections.json): без него «назад» на /collections менял
    // адрес, а на экране оставалась прошлая коллекция (баг-хантинг 05.10.2026).
    window.addEventListener('popstate', function () {
      if (!/^\/collections(\/[^/]+)?\/?$/.test(window.location.pathname)) return;
      if (pathOf(window.location.href) === shown) return;
      go(window.location.href, false, null);
    });

    // Соседние коллекции — заранее, в простое: вкладки и чипсы срабатывают мгновенно.
    if (sectionId) idle(function () {
      var seen = {};
      hub.querySelectorAll('.hub__tab, .hub__dd-item, .hub__chip').forEach(function (a) {
        var k = pathOf(a.href);
        if (!seen[k] && Object.keys(seen).length < 8) { seen[k] = true; prefetch(a); }
      });
    });

    // Вернулись со страницы товара, а браузер не знает pagereveal (там это делает
    // lunea-transitions до первого кадра): прокрутка туда, где были.
    // behavior: 'instant' — в теме scroll-behavior: smooth.
    if (!('onpagereveal' in window)) {
      try {
        var ret = JSON.parse(sessionStorage.getItem('lunea:return') || 'null');
        if (ret && ret.url === window.location.pathname + window.location.search) {
          sessionStorage.removeItem('lunea:return');
          if (ret.y) window.scrollTo({ top: ret.y, behavior: 'instant' });
        }
      } catch (err) {}
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunea-header"]) return;
  try {
    
  /* Мобильное меню на <details>. Открытие/закрытие НЕ отдано браузеру: нативный
     клик по <summary> перехватывается и гасится (preventDefault), open/close
     делает JS через явные функции. Причина — открытие <details> само по себе
     (даже программный menu.open = true, без всякого клика — проверено) сбрасывает
     scrollY в 0 в Chromium при sticky-предке: тянет какой-то внутренний
     «прокрутить к раскрытому блоку». Слушать событие toggle было поздно —
     к моменту его срабатывания scrollY уже испорчен, поэтому и body.style.top
     считался от уже сброшенного числа. Ловим ДО открытия, на клике, с
     preventDefault — тогда открываем сами, когда страница уже заморожена. */
  (function () {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    var summary = menu.querySelector('summary');
    var closeBtn = menu.querySelector('[data-menu-close]');
    var panel = menu.querySelector('.header__mobile-panel');
    var lockedScrollY = 0;

    function openMenu() {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      if (panel) {
        // Позиция панели: CSS держит top: var(--header-h) на случай если JS
        // не сработает, но это верно только когда шапка сидит в самом верху
        // экрана. При scrollY = 0 над шапкой ещё полоса анонса (~38px) —
        // header.bottom больше var(--header-h), без поправки панель
        // перекрывала бы островки шапки. Меряем, пока страница ещё не
        // заморожена — геометрия натуральная.
        var bottom = menu.closest('.header').getBoundingClientRect().bottom;
        panel.style.top = bottom + 'px';
        panel.style.height = 'calc(100dvh - ' + bottom + 'px)';
      }
      // Блокировка НЕ через overflow:hidden — он сам по себе тоже сбрасывает
      // scrollY и не восстанавливает при снятии. body становится fixed со
      // смещением top на -scrollY: страница замирает визуально там же, где
      // была; native-сброс, который вот-вот попытается устроить <details>,
      // уже не на чем сработать — скроллить нечего, body вне потока.
      document.body.style.position = 'fixed';
      document.body.style.top = (-lockedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      menu.open = true;
    }

    function closeMenu() {
      menu.open = false;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      // instant: в lunea.css html { scroll-behavior: smooth } — без этого страница «доезжала» на место (26.10.2026)
      window.scrollTo({ top: lockedScrollY, left: 0, behavior: 'instant' });
      if (panel) { panel.style.top = ''; panel.style.height = ''; }
    }

    if (summary) {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (menu.open) closeMenu(); else openMenu();
      });
    }

    // Крестик внутри панели.
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeMenu();
        // preventScroll: иначе фокус на кнопке меню прокручивал страницу к ней и сбивал возврат на место
        if (summary) summary.focus({ preventScroll: true });
      });
    }

    // Esc и переход на десктопную ширину закрывают меню, иначе оно останется
    // открытым и залочит скролл на широком экране.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) closeMenu();
    });
    window.addEventListener('resize', function () {
      if (menu.open && window.innerWidth > 860) closeMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunea-product"]) return;
  try {
    
  /* Страница товара: «← Back to …» туда, откуда пришли; ‹ › переключают товар без
     перезагрузки — секция приходит через Section Rendering API, страница сдвигается
     вбок (View Transitions), адрес меняется (pushState, «назад» работает). Соседей
     подгружаем заранее, поэтому ‹ › срабатывают мгновенно. Не вышло — обычный переход.
     Счётчик и полноэкранный просмотр фото. Спека §5, §7. */
  (function () {
    var first = document.querySelector('.product[data-product-section]');
    if (!first) return;
    var section = first.closest('.shopify-section');
    var sectionId = section ? section.id.replace(/^shopify-section-/, '') : '';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 700); };
    var cache = {};

    function readHub() {
      try { return JSON.parse(sessionStorage.getItem('lunea:hub') || 'null'); } catch (err) { return null; }
    }
    function fetchHtml(url) {
      var key = new URL(url, window.location.href).pathname;
      if (!cache[key]) {
        var u = new URL(url, window.location.href);
        u.search = '';
        u.searchParams.set('section_id', sectionId);
        cache[key] = fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        });
        cache[key].catch(function () { delete cache[key]; });
      }
      return cache[key];
    }

    // «← Back to …»: хаб ещё в истории вкладки — возвращаемся в него «назад», браузер
    // достаёт страницу как была (прокрутка), а фото улетает обратно в плитку.
    function back(e, a, bar, y) {
      var target = new URL(a.href, window.location.href);
      var want = target.pathname + target.search;
      try {
        sessionStorage.setItem('lunea:return', JSON.stringify({ url: want, y: y, handle: bar.getAttribute('data-product') }));
      } catch (err) {}
      if (window.navigation && navigation.entries && navigation.currentEntry) {
        var entries = navigation.entries();
        for (var i = navigation.currentEntry.index - 1; i >= 0; i--) {
          var u = new URL(entries[i].url);
          if (u.pathname + u.search === want) {
            e.preventDefault();
            navigation.traverseTo(entries[i].key);
            return;
          }
        }
      }
    }

    function step(url, dir, push) {
      fetchHtml(url).then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('.product[data-product-section]');
        if (!next) throw new Error('no product');
        next.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
        var current = document.querySelector('.product[data-product-section]');
        var oldTitle = current.querySelector('.product__title').textContent.trim();
        function update() {
          current.replaceWith(next);
          if (push) { idx++; history.pushState({ luneaProduct: true, luneaIdx: idx }, '', url); }
          shownPath = new URL(url, window.location.href).pathname;
          var newTitle = next.querySelector('.product__title').textContent.trim();
          document.title = document.title.replace(oldTitle, newTitle);
          window.scrollTo({ top: 0, behavior: 'instant' });
          bind(next);
        }
        try { sessionStorage.removeItem('lunea:dir'); } catch (err) {}
        if (!document.startViewTransition || reduce.matches) { update(); return; }
        var root = document.documentElement;
        var cls = 'is-vt-' + dir;
        root.classList.add(cls);
        var t = document.startViewTransition(update);
        t.finished.finally(function () { root.classList.remove(cls); });
      }).catch(function () { window.location.href = url; });
    }

    function bindGallery(article) {
      var gallery = article.querySelector('[data-gallery]');
      if (!gallery) return;
      var shots = gallery.querySelectorAll('.product__shot');
      var count = article.querySelector('[data-count]');
      if (count && shots.length > 1) {
        gallery.addEventListener('scroll', function () {
          var w = shots[1].offsetLeft - shots[0].offsetLeft;
          var i = w > 0 ? Math.round(gallery.scrollLeft / w) : 0;
          count.textContent = Math.min(shots.length, i + 1) + ' / ' + shots.length;
        }, { passive: true });
      }
      var viewer = article.querySelector('[data-viewer]');
      if (!viewer || !viewer.showModal) return;
      var strip = viewer.querySelector('[data-viewer-strip]');
      var vcount = viewer.querySelector('[data-viewer-count]');
      var slides = strip.children.length;
      function vIndex() { return Math.round(strip.scrollLeft / strip.clientWidth); }
      function vUpdate() { if (vcount) vcount.textContent = (vIndex() + 1) + ' / ' + slides; }
      function vGo(d) { strip.scrollBy({ left: d * strip.clientWidth, behavior: 'smooth' }); }
      gallery.addEventListener('click', function (e) {
        var b = e.target.closest('[data-open]');
        if (!b) return;
        viewer.showModal();
        // Своя запись в истории: «назад» на телефоне (жест Android, свайп от края в iOS)
        // закрывает просмотр, а не уводит со страницы товара (баг-хантинг 05.10.2026).
        try { history.pushState({ luneaViewer: true, luneaIdx: idx }, '', window.location.href); } catch (err) {}
        strip.scrollTo({ left: Number(b.getAttribute('data-open')) * strip.clientWidth, behavior: 'instant' });
        vUpdate();
      });
      // Закрыли крестиком, тапом мимо или Escape — снимаем свою запись из истории.
      viewer.addEventListener('close', function () {
        if (history.state && history.state.luneaViewer) history.back();
      });
      strip.addEventListener('scroll', vUpdate, { passive: true });
      viewer.addEventListener('click', function (e) {
        var s = e.target.closest('[data-viewer-step]');
        if (s) { vGo(Number(s.getAttribute('data-viewer-step'))); return; }
        if (e.target.closest('[data-viewer-close]') || e.target === viewer || e.target.classList.contains('pviewer__slide')) viewer.close();
      });
      viewer.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') vGo(1);
        if (e.key === 'ArrowLeft') vGo(-1);
      });
    }

    function bind(article) {
      var bar = article.querySelector('[data-pctx]');
      if (bar) {
        var hub = readHub();
        var fromHub = !!(hub && hub.ctx === bar.getAttribute('data-ctx'));
        article.querySelectorAll('[data-pctx-back]').forEach(function (a) {
          if (fromHub) {
            a.href = hub.url;
            var l = a.querySelector('[data-pctx-label]');
            if (l) l.textContent = hub.label;
          }
          a.addEventListener('click', function (e) { back(e, a, bar, fromHub ? hub.y : 0); });
        });
        bar.querySelectorAll('[data-step]').forEach(function (a) {
          a.addEventListener('click', function (e) {
            if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            var dir = a.getAttribute('data-step');
            // на случай обычного перехода — сдвиг сделает lunea-transitions
            try { sessionStorage.setItem('lunea:dir', dir); } catch (err) {}
            if (!sectionId) return;
            e.preventDefault();
            step(a.href, dir, true);
          });
        });
        idle(function () {
          bar.querySelectorAll('[data-step]').forEach(function (a) { fetchHtml(a.href).catch(function () {}); });
        });
      }
      bindGallery(article);
    }

    // Add to cart без ухода со страницы. data-state: idle → loading (запрос; не меньше 1100 мс —
    // темп оригинала AsyncButton) → success «✓ Added» (1400 мс) → idle. Счётчик в шапке
    // обновляется, иконка корзины трижды пульсирует. Записка к подарку ушла с этим боксом —
    // поле очищаем. Ошибка (закончился, лимит) — кнопка возвращается, текст Shopify под ней.
    // Нет fetch — уходит обычной формой в /cart.
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var LOADING = reduce.matches ? 80 : 1100;
    var SUCCESS = reduce.matches ? 600 : 1400;
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function setState(btn, s) { btn.setAttribute('data-state', s); btn.disabled = s !== 'idle'; }
    function countAndPulse(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
      if (reduce.matches) return;
      document.querySelectorAll('.header__cart').forEach(function (c) {
        c.classList.remove('is-pulse');
        void c.offsetWidth; // перезапуск анимации, если добавили второй раз подряд
        c.classList.add('is-pulse');
      });
    }
    document.addEventListener('animationend', function (e) {
      if (e.animationName === 'lunea-cart-pulse' && e.target.classList) e.target.classList.remove('is-pulse');
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.product__form')) return;
      var btn = form.querySelector('.product__atc');
      if (!btn || !window.fetch || !window.FormData || !window.Promise) return;
      e.preventDefault();
      if (btn.getAttribute('data-state') !== 'idle') return;
      var err = form.querySelector('[data-atc-error]');
      var live = form.querySelector('[data-atc-live]');
      if (err) { err.hidden = true; err.textContent = ''; }
      if (live) live.textContent = '';
      var data = new FormData(form);
      // Пустую записку не шлём: обычная форма такие поля отбрасывала, а /cart/add.js сохраняет
      // пустое «Gift message:» в заказе — и бокс без записки встаёт отдельной строкой.
      var empty = [];
      data.forEach(function (v, k) { if (/^properties\[/.test(k) && !String(v).trim()) empty.push(k); });
      empty.forEach(function (k) { data.delete(k); });
      var started = Date.now();
      function rest() { return wait(Math.max(0, LOADING - (Date.now() - started))); }
      setState(btn, 'loading');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .catch(function () { return null; });
        })
        .then(function (cart) {
          return rest().then(function () {
            setState(btn, 'success');
            if (live) live.textContent = live.getAttribute('data-text');
            var note = form.querySelector('[name="properties[Gift message]"]');
            if (note) note.value = '';
            if (cart) countAndPulse(cart.item_count);
            return wait(SUCCESS).then(function () {
              setState(btn, 'idle');
              if (live) live.textContent = '';
            });
          });
        }, function (j) {
          return rest().then(function () {
            setState(btn, 'idle');
            if (err) {
              err.textContent = (j && j.description) || err.getAttribute('data-generic');
              err.hidden = false;
            }
          });
        });
    });
    // Вернулись «назад» из кэша браузера посреди анимации — кнопка снова обычная.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('.product__atc[data-state]:not([data-state="idle"])').forEach(function (b) { setState(b, 'idle'); });
    });

    // История: idx — номер записи (растёт на ‹ ›), по нему «назад»/«вперёд» едут в свою
    // сторону. shownPath — какой товар на экране: popstate без смены пути (якорь #main из
    // skip-link, закрытие просмотра фото) секцию не перерисовывает — иначе стиралась
    // записка к подарку и страница прыгала наверх (баг-хантинг 05.10.2026).
    var idx = (history.state && history.state.luneaIdx) || 0;
    var shownPath = window.location.pathname;
    bind(first);
    window.addEventListener('popstate', function (e) {
      document.querySelectorAll('dialog[data-viewer][open]').forEach(function (d) { d.close(); });
      var to = (e.state && e.state.luneaIdx) || 0;
      var dir = to < idx ? 'prev' : 'next';
      idx = to;
      if (!/\/products\//.test(window.location.pathname) || window.location.pathname === shownPath) return;
      step(window.location.href, dir, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunea-rail"] && !Shopify.designMode) return;
  try {
    
  /* Один и тот же код может стоять на странице несколько раз (второй рельс
     придёт с Christmas) — querySelectorAll + guard railInit, не querySelector. */
  (function () {
    function init(rail) {
      if (rail.dataset.railInit) return;
      rail.dataset.railInit = '1';

      var track = rail.querySelector('[data-rail-track]');
      var prev = rail.querySelector('[data-rail-prev]');
      var next = rail.querySelector('[data-rail-next]');
      var arrows = rail.querySelector('[data-rail-arrows]');
      if (!track || !prev || !next) return;

      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        return first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      }

      // Плитки за краем трека никогда не пересекают вьюпорт — общий .reveal
      // observer их не покажет. Как только человек взаимодействует с рельсом,
      // показываем всё разом, а не ждём индивидуального пересечения.
      function revealAll() {
        track.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (arrows) arrows.hidden = max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      }

      function go(dir) {
        revealAll();
        track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('scroll', revealAll, { once: true, passive: true });
      window.addEventListener('resize', update);
      update();
      if ('ontouchstart' in window && matchMedia('(hover: none) and (pointer: coarse)').matches) touchLock();

      /* Блокировка оси на тач (просьба Михаила 29.09: при свайпе вбок страница
         не должна ехать вверх-вниз). Ось решается по первому движению пальца:
         вбок — рельс ведёт палец сам (браузеру горизонталь отключена через
         touch-action: pan-y), страница стоит; вверх-вниз — не вмешиваемся, скроллится
         страница. Так палец на карточках по-прежнему листает страницу вниз.
         Отпустили — докатываемся до ближайшей карточки с учётом скорости свайпа,
         на время протяжки scroll-snap снят, иначе он спорит с пальцем. */
      function touchLock() {
        track.classList.add('is-touchlock');
        var x0 = 0, y0 = 0, left0 = 0, axis = null, samples = [], dragged = false;
        var FLING_MS = 220;
        var FLICK_V = 0.3;   // px/мс

        function snapPoints() {
          var tiles = track.children;
          if (!tiles.length) return [0];
          var base = tiles[0].getBoundingClientRect().left;
          var max = track.scrollWidth - track.clientWidth;
          var pts = [];
          for (var i = 0; i < tiles.length; i++) {
            pts.push(Math.min(max, Math.max(0, tiles[i].getBoundingClientRect().left - base)));
          }
          pts.push(max);
          return pts;
        }
        function restoreSnap() { track.style.scrollSnapType = ''; }

        track.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { axis = 'none'; return; }
          var t = e.touches[0];
          x0 = t.clientX; y0 = t.clientY; left0 = track.scrollLeft;
          axis = null; dragged = false;
          samples = [{ x: t.clientX, t: performance.now() }];
        }, { passive: true });

        track.addEventListener('touchmove', function (e) {
          if (axis === 'none' || axis === 'y') return;
          var t = e.touches[0];
          var dx = t.clientX - x0;
          var dy = t.clientY - y0;
          if (axis === null) {
            if (dx === 0 && dy === 0) return;
            // Браузер уже начал вертикальный скролл — событие не отменить, ось y.
            if (!e.cancelable || Math.abs(dy) > Math.abs(dx)) { axis = 'y'; return; }
            axis = 'x';
            track.style.scrollSnapType = 'none';
            revealAll();
          }
          e.preventDefault();
          if (Math.abs(dx) > 6) dragged = true;
          track.scrollLeft = left0 - dx;
          samples.push({ x: t.clientX, t: performance.now() });
          if (samples.length > 5) samples.shift();
        }, { passive: false });

        function end() {
          if (axis !== 'x') { axis = null; return; }
          axis = null;
          var a = samples[0];
          var b = samples[samples.length - 1];
          var v = b.t > a.t ? (b.x - a.x) / (b.t - a.t) : 0;   // px/ms, + палец вправо
          var target = track.scrollLeft - v * FLING_MS;
          var pts = snapPoints();
          var best = pts[0];
          pts.forEach(function (p) {
            if (Math.abs(p - target) < Math.abs(best - target)) best = p;
          });
          // Уверенный свайп (быстрее медленной протяжки) — минимум одна карточка
          // в сторону жеста от той, с которой начали, даже если палец прошёл мало.
          if (Math.abs(v) > FLICK_V) {
            var from = 0;
            pts.forEach(function (p, i) { if (Math.abs(p - left0) < Math.abs(pts[from] - left0)) from = i; });
            var next = pts[Math.max(0, Math.min(pts.length - 1, from + (v < 0 ? 1 : -1)))];
            if (v < 0 ? best < next : best > next) best = next;
          }
          track.scrollTo({ left: best, behavior: reduce ? 'auto' : 'smooth' });
          // Snap возвращаем только когда докатились до цели: scrollend от самой
          // протяжки может прийти раньше, и включённый mandatory-snap вернул бы
          // рельс к ближайшей карточке от точки, где отпустили палец.
          var deadline = Date.now() + 900;
          (function waitArrive() {
            if (Math.abs(track.scrollLeft - best) <= 1 || Date.now() > deadline) { restoreSnap(); return; }
            requestAnimationFrame(waitArrive);
          })();
        }
        track.addEventListener('touchend', end);
        track.addEventListener('touchcancel', end);

        // Протяжка — не нажатие: ссылку плитки под пальцем не открываем.
        track.addEventListener('click', function (e) {
          if (!dragged) return;
          dragged = false;
          e.preventDefault();
          e.stopPropagation();
        }, true);
      }
    }

    document.querySelectorAll('[data-rail]').forEach(init);
    // Редактор темы подгружает секцию заново при правке настроек — переинициализация.
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-rail]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunea-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function easeOut(p) { return 1 - Math.pow(1 - p, 2); }

    function init(root) {
      if (!root || root.dataset.storyInit) return;
      root.dataset.storyInit = '1';

      // Видео крутим, только пока кадр в окне. Стоит ДО раннего выхода ниже: иначе в
      // современных браузерах (и при reduced motion) ролики глав крутились всё время,
      // пока открыта вкладка, — батарея и трафик на телефоне (баг-хантинг 05.10.2026).
      var videos = root.querySelectorAll('video');
      if (videos.length && 'IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { var p = en.target.play(); if (p && p.catch) p.catch(function () {}); }
            else en.target.pause();
          });
        });
        videos.forEach(function (v) { vio.observe(v); });
      }

      // Браузер сам ведёт scroll-driven анимации (см. stylesheet) — JS нужен только старым.
      if (reduce.matches || (window.CSS && CSS.supports('animation-timeline: view()'))) return;

      var chapters = Array.prototype.map.call(root.querySelectorAll('[data-story-ch]'), function (ch) {
        return { media: ch.querySelector('[data-story-media]'), text: ch.querySelector('[data-story-text]') };
      }).filter(function (c) { return c.media && c.text; });
      var active = false;
      var queued = false;

      // Прогресс элемента: 0, когда его верх у низа окна (from · vh), 1 — когда дошёл до to · vh.
      function progress(el, vh, from, to) {
        var top = el.getBoundingClientRect().top;
        return easeOut(clamp((from * vh - top) / ((from - to) * vh)));
      }

      // Значения догоняют цель с инерцией (lerp 0.18 за кадр), а не прыгают
      // за каждым событием скролла: на старых телефонах события приходят рывками.
      var LERP = 0.18;
      chapters.forEach(function (c) { c.m = null; c.t = null; });
      function update() {
        queued = false;
        var vh = window.innerHeight;
        var moving = false;
        chapters.forEach(function (c) {
          var tm = progress(c.media, vh, 1, 0.3);
          var tt = progress(c.text, vh, 0.95, 0.4);
          c.m = c.m === null ? tm : c.m + (tm - c.m) * LERP;
          c.t = c.t === null ? tt : c.t + (tt - c.t) * LERP;
          if (Math.abs(tm - c.m) < 0.001) c.m = tm; else moving = true;
          if (Math.abs(tt - c.t) < 0.001) c.t = tt; else moving = true;
          c.media.style.setProperty('--pm', c.m.toFixed(4));
          c.text.style.setProperty('--pt', c.t.toFixed(4));
        });
        if (moving) request();
      }
      function request() {
        if (!active || queued) return;
        queued = true;
        requestAnimationFrame(update);
      }

      // Считаем только пока секция рядом с окном; вне его значения замирают там, где были.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          active = entries[0].isIntersecting;
          if (active) request();
        }, { rootMargin: '20% 0px' }).observe(root);
      } else {
        active = true;
      }
      update();
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
    }

    document.querySelectorAll('[data-story]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-story]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
